import styled from "@mui/material/styles/styled";
import MTabs from "@mui/material/Tabs";
import { TABS_TOKENS } from "../../shared/constants";
import { ETabVariants } from "../Tab";
var ETabsSize = /* @__PURE__ */ ((ETabsSize2) => {
  ETabsSize2["L"] = "L";
  ETabsSize2["M"] = "M";
  ETabsSize2["S"] = "S";
  return ETabsSize2;
})(ETabsSize || {});
const Tabs = styled(MTabs)((props) => {
  const { theme, size = "M" /* M */, tabVariant, showIndicator = true } = props;
  const palette = theme.palette;
  const isSizeS = size === "S" /* S */;
  const isLongHorizontal = tabVariant === ETabVariants.HORIZONTAL;
  const isHorizontal = isLongHorizontal || tabVariant === ETabVariants.SHORT_HORIZONTAL;
  const isLongVertical = tabVariant === ETabVariants.VERTICAL;
  const isVertical = tabVariant === ETabVariants.SHORT_VERTICAL || tabVariant === ETabVariants.VERTICAL;
  const hideIndicator = isLongHorizontal && isSizeS || isLongVertical;
  const renderIndicator = !hideIndicator && showIndicator;
  const activeIndicatorColor = palette.brand.main;
  const tabGap = `${TABS_TOKENS[tabVariant].tabsGap[size]}px`;
  return {
    borderBottom: isHorizontal ? "1px solid var(--mui-palette-lines-dividerBright)" : "none",
    minHeight: "unset",
    "& .MuiTabs-indicator": {
      backgroundColor: activeIndicatorColor,
      display: renderIndicator ? "" : "none",
      left: isVertical && 0
    },
    "& .MuiTabs-scroller": {
      height: "100%"
    },
    "& .MuiTabs-flexContainer": {
      gap: tabGap
    }
  };
});
var Tabs_default = Tabs;
export {
  ETabsSize,
  Tabs_default as default
};
